import { SET_PARTNERS_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_PARTNERS_SETTINGS, {
  pageSize: 10,
  currentPage: 1,
  status: 'ALL',
  search: ''
})
